
import moment from 'moment/moment';

/**
 * Calculates the duration between two moment dates and returns an object with hours, minutes, and years.
 * @param {moment.Moment} end - The end date as a moment object.
 * @param {moment.Moment} start - The start date as a moment object.
 * @returns {{hours: number, minutes: number, years: number} | null} An object with hours, minutes, and years, or null if start or end is missing.
 */
export const getDuration = (end, start) => {
    if (start && end) {
        const duration = moment.duration(end.diff(start));

        return {
            hours: duration.hours(),
            minutes: duration.minutes(),
            years: duration.years(),
        };
    } else {
        return null;
    }
};
